import { Link, useLocation } from "react-router-dom";
import { LiaPhoneVolumeSolid } from "react-icons/lia";
import { HiOutlineMailOpen } from "react-icons/hi";
import { FaInstagram } from "react-icons/fa6";
import { PiTiktokLogo } from "react-icons/pi";
import { cn } from "../utils";
import { RootState, useAppDispatch, useAppSelector } from "../store";
import { IoClose, IoMenu } from "react-icons/io5";
import { handleModal } from "../store/slices/modal";
import { useRef } from "react";
import { MenuNavMobile, ModalLayout } from "./";

const Header = () => {
  const location = useLocation()
  const dispatch = useAppDispatch()
  const modalMenuNavMobileIsActive = useAppSelector((state: RootState) => state.modal.modalMenuNavMobileIsActive)
  const refMenuNavContainer = useRef<HTMLElement>(null)

  const switchEffect = (value: "inicio" | "nosotros" | "servicios" | "contacto") => {
    return value != "inicio" ? location.pathname === `/${value}` : location.pathname === `/`
  }

  const handleOpenMenuNavMobile = () => {
    const element = refMenuNavContainer.current;
    if (element) {
      const elementRect = element.getBoundingClientRect();
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const offsetTop = elementRect.top + scrollTop;
      const offset = offsetTop; // Puedes ajustar este valor según sea necesario
      window.scrollTo({
        top: offset,
        behavior: 'smooth'
      });
      setTimeout(() => {
        document.body.style.overflow = 'hidden';
        dispatch(handleModal({
          typeModal: "menuNavMobile",
          display: true
        }))
      }, 300);
    }
  }

  const handleCloseMenuNavMobile = (e?: React.MouseEvent<HTMLOrSVGElement>) => {
    e?.stopPropagation()
    const container = document.querySelector('#menu-nav-on-mobile') as HTMLElement;
    if (container) {
      // console.log(modalMenuNavMobileIsActive);
      container.classList.add('modal-exit-left');
      setTimeout(() => {
        document.body.style.overflow = 'auto';
        dispatch(handleModal({
          typeModal: "menuNavMobile",
          display: false
        }))
      }, 300);
    }
  }

  return (
    <header className="w-full">
      {/* CONTACTO */}
      <section className="hidden w-full h-auto py-3 lg:py-2 md:py-0 md:h-12 bg-secondary text-white font-tommy-light">
        <div className="w-full sm:w-[90%] mx-auto flex gap-y-3 flex-col sm:flex-row justify-center sm:justify-between items-center h-full">
          {/* TELEFONO Y CORREO */}
          <div className="flex items-center gap-3 text-sm sm:text-base">
            <a href="tel:+51973559725" className="flex items-center gap-2">
              <LiaPhoneVolumeSolid size={25} />
              +51 973559725
            </a>
            <span className="opacity-80">|</span>
            <a href="mailto:info@example.com" className="flex items-center gap-2">
              <HiOutlineMailOpen size={25} className="opacity-80" />
              info@example.com
            </a>
          </div>
          {/* REDES SOCIALES */}
          <div className="flex gap-2 sm:gap-4 text-2xl sm:text-3xl">
            <a href="https://www.tiktok.com/@tuvisa360pe?_t=8lAHwpJO7zi&_r=1" target="_blank" rel="noopener noreferrer"><PiTiktokLogo /></a>
            <a href="https://www.instagram.com/tuvisa360pe/?igsh=MTRjeWFxMzQzMDFhYQ%3D%3D" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          </div>
        </div>
      </section>
      {/* MENU DE NAVEGACION */}
      <section ref={refMenuNavContainer} className="w-[95%] md:w-[90%] mx-auto h-16 lg:h-24 flex justify-between items-center text-text-primary font-tommy-bold">
        {/* LOGO */}
        <Link to="/" className="h-12 w-max lg:h-14"><img src="/images/logo.jpeg" alt="logo" className="h-full w-full object-contain" /></Link>
        {/* NAVEGACION WEB*/}
        <nav className="hidden lg:flex gap-5 font-tommy-regular">
          <Link to="/" className={cn("hover:text-primary transition-all duration-500", switchEffect("inicio") && "text-primary")}>INICIO</Link>
          <a href="#nosotros" className={cn("hover:text-primary transition-all duration-500", switchEffect("nosotros") && "text-primary")}>NOSOTROS</a>
        </nav>
        {/* NAVEGACION MOBILE */}
        <button
          type="button"
          onClick={handleOpenMenuNavMobile}
          className="block lg:hidden menu-nav-button-store pr-2 text-primary"
        >
          {
            modalMenuNavMobileIsActive
              ? <IoClose size={25} className="rotateIn" onClick={(e) => handleCloseMenuNavMobile(e)} />
              : <IoMenu size={25} className="rotateOut" />
          }
        </button>
      </section>
      {/* MENU EN MOBILE */}
      <ModalLayout onClose={handleCloseMenuNavMobile} typeModal="menu-nav-mobile" isActive={modalMenuNavMobileIsActive}
        className="top-16"
      >
        <MenuNavMobile switchEffect={switchEffect} onClose={handleCloseMenuNavMobile} />
      </ModalLayout>
    </header>
  );
}

export default Header;